import { useLayoutStore } from "@/Stores/layout"
import { useLocaleStore } from "@/Stores/locale"
import { router, usePage } from "@inertiajs/vue3"
// import { loadLanguageAsync } from "laravel-vue-i18n"
import { watchEffect } from "vue"
import { useEchoGrpPersonal } from '@/Stores/echo-grp-personal.js'
import { useEchoGrpGeneral } from '@/Stores/echo-grp-general.js'
import { useLiveUsers } from '@/Stores/active-users'

export const initialiseApp = () => {
    const layout = useLayoutStore()
    const locale = useLocaleStore()

    // Declaring here cuz some component failing retrieve on first load (EmployeePosition.vue)
    layout.currentParams = route().v().params
    router.on('navigate', (event) => {
        // console.log('layout env', layout.app.environment)
        layout.currentParams = route().v().params  // current params
        layout.currentRoute = route().current() || ''  // current route
    })


    const echoPersonal = useEchoGrpPersonal()
    const echoGeneral = useEchoGrpGeneral()

    useLiveUsers().subscribe()  // Websockets: active users
    echoGeneral.subscribe(usePage().props.layout?.group?.id)  // Websockets: notification

    console.log('usePage().props.app?.environment', usePage().props.app?.environment)
    watchEffect(() => {

        layout.auth = usePage().props.auth

        layout.app.environment = usePage().props.app?.environment ?? 'local'
        layout.app.name = "Repro"
    })
}
